import { useEffect, useState } from "react";

/* ---------- Internal Bus ---------- */
type Listener = (msg: string) => void;
let listeners: Listener[] = [];
let queue: string[] = [];
let isAnnouncing = false;

/* ---------- Public API ---------- */
export function announce(message: string) {
  queue.push(message);
  processQueue();
}

function processQueue() {
  if (isAnnouncing || queue.length === 0) return;
  isAnnouncing = true;
  const msg = queue.shift();
  if (!msg) return;

  listeners.forEach((fn) => fn(msg));
}

/* ---------- Component ---------- */
export function AriaLiveRegion() {
  const [message, setMessage] = useState("");

  useEffect(() => {
    const handler = (msg: string) => {
      setMessage(msg);

      // clear after SR read cycle
      setTimeout(() => {
        setMessage("");
        isAnnouncing = false;
        processQueue(); // process next
      }, 1200);
    };

    listeners.push(handler);
    return () => {
      listeners = listeners.filter((l) => l !== handler);
    };
  }, []);

  return (
    <>
      {/* Polite channel */}
      <div
        aria-live="polite"
        aria-atomic="true"
        role="status"
        className="sr-only"
      >
        {message}
      </div>
    </>
  );
}
